var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { siteX } from "../interceptors/api";
const getAllAlarmCauses = (query) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("AlarmCauses/get-all", query);
    return response;
});
const getAlarmCauseById = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.get(`AlarmCauses/${id}`);
    return response;
});
const createAlarmCause = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.post("AlarmCauses/create", data);
    return response;
});
const updateAlarmCause = (data) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.put("AlarmCauses/update", data);
    return response;
});
const deleteAlarmCause = (id) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield siteX.delete(`AlarmCauses/${id}`);
    return response;
});
export const alarmCausesApi = {
    getAllAlarmCauses,
    getAlarmCauseById,
    createAlarmCause,
    updateAlarmCause,
    deleteAlarmCause,
};
